import script from "./CompareModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompareModal.vue?vue&type=script&setup=true&lang=js"

import "./CompareModal.vue?vue&type=style&index=0&id=4a7f60e5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7f60e5"]])

export default __exports__